'use client';

import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useSession } from '@/lib/AuthContext';
import { useSuperAdmin } from '@/hooks/useSuperAdmin';
import { LoadingPage } from '@/components/LoadingPage';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, isLoading: sessionLoading } = useSession();
  const { isSuperAdmin, isLoading: superAdminLoading } = useSuperAdmin();

  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  const returnPath = encodeURIComponent(location.pathname + location.search);

  useEffect(() => {
    if (!sessionLoading && !superAdminLoading && !session) {
      navigate(`/login?return=${returnPath}`, { replace: true });
    }
  }, [session, sessionLoading, superAdminLoading, navigate, returnPath]);

  if (!mounted || sessionLoading || superAdminLoading) {
    return <LoadingPage />;
  }

  if (!session) {
    return <LoadingPage />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground mb-2">Acceso Denegado</h1>
          <p className="text-muted-foreground">
            Solo los Super Administradores pueden acceder a esta sección.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
